import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import MerciPage from "./pages/MerciPage";
import RapportPage from "./pages/RapportPage";
import AdminPage from "./pages/AdminPage";
import ManagementLeadershipPage from "./pages/ManagementLeadershipPage";
import SoftSkillsPage from "./pages/SoftSkillsPage";
import DigitalWebPage from "./pages/DigitalWebPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import CGVPage from "./pages/CGVPage";
import ContactPage from "./pages/ContactPage";
import MerciContactPage from "./pages/MerciContactPage";
import SimulationROIPage from "./pages/SimulationROIPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/merci" element={<MerciPage />} />
            <Route path="/merci-contact" element={<MerciContactPage />} />
            <Route path="/rapport" element={<RapportPage />} />
            <Route path="/simulation-roi" element={<SimulationROIPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/management-leadership" element={<ManagementLeadershipPage />} />
            <Route path="/soft-skills" element={<SoftSkillsPage />} />
            <Route path="/digital-web" element={<DigitalWebPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/confidentialite" element={<ConfidentialitePage />} />
            <Route path="/cgv" element={<CGVPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
